import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Uploads the chosen file straight to storage, fills the hidden signed id and
// pre-fills name/duration from the file (image dimensions, video duration).
export default class extends Controller {
  static targets = ["input", "progress", "bar", "signedId", "name", "duration", "submit"]
  static values = { url: String }

  connect() {
    this.inputTarget.addEventListener("change", this.onChange)
  }

  disconnect() {
    this.inputTarget.removeEventListener("change", this.onChange)
  }

  onChange = () => {
    const file = this.inputTarget.files[0]
    if (!file) return
    this.prefill(file)
    this.upload(file)
  }

  prefill(file) {
    if (this.hasNameTarget && !this.nameTarget.value) this.nameTarget.value = file.name.replace(/\.[^.]+$/, "")
    if (this.hasDurationTarget && file.type.startsWith("video/")) {
      const video = document.createElement("video")
      video.preload = "metadata"
      video.onloadedmetadata = () => {
        if (isFinite(video.duration)) this.durationTarget.value = Math.ceil(video.duration)
        URL.revokeObjectURL(video.src)
      }
      video.src = URL.createObjectURL(file)
    }
  }

  upload(file) {
    this.setBusy(true)
    const upload = new DirectUpload(file, this.urlValue, this)
    upload.create((error, blob) => {
      this.setBusy(false)
      if (error) {
        this.progressTarget.textContent = error
        return
      }
      this.signedIdTarget.value = blob.signed_id
      this.inputTarget.value = ""
      this.progressTarget.textContent = `${file.name} · pronto`
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", (event) => {
      const pct = Math.round((event.loaded / event.total) * 100)
      this.barTarget.style.width = `${pct}%`
      this.progressTarget.textContent = `Enviando… ${pct}%`
    })
  }

  setBusy(busy) {
    if (this.hasSubmitTarget) this.submitTarget.disabled = busy
    this.progressTarget.classList.remove("hidden")
    if (!busy) this.barTarget.style.width = "100%"
  }
}
